<template>
  <v-card class="white--text">
    <v-card-title class="title blue lighten-2">
      วิทยากร
    </v-card-title>
    <v-card-text class="pa-0 blue lighten-1">
      <v-container grid-list-md text-xs-center fluid class="pa-2">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-autocomplete
              :items="academicYearItems"
              v-model="academicYear"
              item-value="id"
              item-text="yearSemester"
              label="ปี/ภาคการศึกษา"
              return-object
              outline
              hide-details
              dark
            ></v-autocomplete>
          </v-flex>
        </v-layout>
      </v-container>
      <v-progress-linear :indeterminate="true" background-color="red lighten-2"
      color="red lighten-3" v-if="academicYear && !show"></v-progress-linear>
    </v-card-text>

    <v-expand-transition>
      <!-- TODO -->
    	<v-tabs
	      v-model="active"
	      color="cyan"
	      fixed-tabs
	      slider-color="yellow"
	      v-if="show"
	    >
	      <v-tab
	        v-for="item in tabItems"
	        :key="item.key"
	        ripple
          class="subheading white--text"
	      >
	        {{ item.label }}

	      </v-tab>
	      <v-tab-item
	        v-for="item in tabItems"
	        :key="item.key"
	      >
	        <v-card flat light>
	          <v-card-text>
							<component :is="item.key" :academicYear="academicYear" :personItems="personItems" :allowedRoles="hasAccess(allowedRoles)"></component>
	        	</v-card-text>
	        </v-card>
	      </v-tab-item>
	    </v-tabs>

    </v-expand-transition>
  </v-card>
</template>

<script>
import { hasAccessMixin } from '@/mixins/hasAccessMixin'
import DataTableLetter from './dataTables/dataTableLetter'
import DataTableParking from './dataTables/dataTableParking'
import DataTableWage from './dataTables/dataTableWage'

export default {
  mixins: [ hasAccessMixin ],
	components: {
    DataTableLetter,
    DataTableParking,
    DataTableWage
  },
	data () {
		return {
      allowedRoles: ['ROLE_ADMIN', 'ROLE_SERVICE'],
			currentView: null,
			academicYearItems: [],
			academicYear: null,
			active: null,
			tabItems: [
				{ key: 'data-table-parking', label: 'ที่จอดรถ' }, 
				{ key: 'data-table-wage', label: 'ค่าตอบแทน' }, 
				{ key: 'data-table-letter', label: 'หนังสือขออนุมัติ' }
			],
			personItems: [],
      show: false
		}
	},
	mounted () {
    this.fetchAcademicYears ()
    this.loadPersons ()
  },
	methods: {
		fetchAcademicYears () {
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
        }).catch((error)=>{
          console.log('reload', error)
        })
    },
    loadPersons () {
      this.$store.dispatch('person/loadItems')
        .then((response) => {
          // console.log('reload:', response.data )
          this.personItems = response.data
        }).catch((error) => {
          swal('Error!', error.message, 'error')
        })
    }
	},
  watch: {
    academicYear (val) {
      if(val) {
        // setTimeout( ()=> this.active = true, 400)
        this.show = false
        setTimeout( ()=> this.show = !this.show, 1000)
      }
    },
    active (val) {
      // console.log('watching active...', val)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/instructor/index.vue